import { createApp } from "vue";
import axios from 'axios';
import './axiosSetup';

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import App from './App.vue';
import router from './router';
import store from './store';

import Vue3Tour from 'vue3-tour'
import 'vue3-tour/dist/vue3-tour.css'

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Ensure Bootstrap JS is included

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

// Import global styles
import '@/assets/css/global.css';
import '@/assets/css/landing.css';

const app = createApp(App);

axios.defaults.withCredentials = true;
const environment = process.env.NODE_ENV;
let backendUrl = 'http://localhost:8000';

if (environment === 'production') {
  backendUrl = "https://notificaciones.gifttarjetas.com.mx";//process.env.VUE_APP_BACKEND_URL;
} else {
  backendUrl = 'http://localhost:8000';
}
axios.defaults.baseURL = backendUrl;


// Lightweight progress bar integration; token / refresh handled in axiosSetup
axios.interceptors.request.use(cfg => { NProgress.start(); return cfg; }, e => { NProgress.done(); return Promise.reject(e); });
axios.interceptors.response.use(r => { NProgress.done(); return r; }, e => { NProgress.done(); return Promise.reject(e); });


app.use(router);
app.use(store);
app.use(Toast);
app.use(Vue3Tour)
app.mount("#app");
